//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/mesh/teleport/automerge.proto (package dxos.mesh.teleport.automerge, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/mesh/teleport/automerge.proto.
 */
export const file_dxos_mesh_teleport_automerge: GenFile = /*@__PURE__*/
  fileDesc("CiJkeG9zL21lc2gvdGVsZXBvcnQvYXV0b21lcmdlLnByb3RvEhxkeG9zLm1lc2gudGVsZXBvcnQuYXV0b21lcmdlIhYKCFBlZXJJbmZvEgoKAmlkGAEgASgJIh4KC1N5bmNNZXNzYWdlEg8KB3BheWxvYWQYAiABKAwyxgEKGkF1dG9tZXJnZVJlcGxpY2F0b3JTZXJ2aWNlElIKEFN0YXJ0UmVwbGljYXRpb24SJi5keG9zLm1lc2gudGVsZXBvcnQuYXV0b21lcmdlLlBlZXJJbmZvGhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5ElQKD1NlbmRTeW5jTWVzc2FnZRIpLmR4b3MubWVzaC50ZWxlcG9ydC5hdXRvbWVyZ2UuU3luY01lc3NhZ2UaFi5nb29nbGUucHJvdG9idWYuRW1wdHliBnByb3RvMw", [file_google_protobuf_empty]);

/**
 * @generated from message dxos.mesh.teleport.automerge.PeerInfo
 */
export type PeerInfo = Message<"dxos.mesh.teleport.automerge.PeerInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message dxos.mesh.teleport.automerge.PeerInfo.
 * Use `create(PeerInfoSchema)` to create a new message.
 */
export const PeerInfoSchema: GenMessage<PeerInfo> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_automerge, 0);

/**
 * @generated from message dxos.mesh.teleport.automerge.SyncMessage
 */
export type SyncMessage = Message<"dxos.mesh.teleport.automerge.SyncMessage"> & {
  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message dxos.mesh.teleport.automerge.SyncMessage.
 * Use `create(SyncMessageSchema)` to create a new message.
 */
export const SyncMessageSchema: GenMessage<SyncMessage> = /*@__PURE__*/
  messageDesc(file_dxos_mesh_teleport_automerge, 1);

/**
 * @generated from service dxos.mesh.teleport.automerge.AutomergeReplicatorService
 */
export const AutomergeReplicatorService: GenService<{
  /**
   * @generated from rpc dxos.mesh.teleport.automerge.AutomergeReplicatorService.StartReplication
   */
  startReplication: {
    methodKind: "unary";
    input: typeof PeerInfoSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc dxos.mesh.teleport.automerge.AutomergeReplicatorService.SendSyncMessage
   */
  sendSyncMessage: {
    methodKind: "unary";
    input: typeof SyncMessageSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_mesh_teleport_automerge, 0);

